
/*
* Initialises the dialog popups
*/

function InitialiseDialogs( page_type ) {
  if( page_type == G_PAGE['MAIN_PAGE'] ) {
    InitialiseMainDialogs();
  }
  else if( page_type == G_PAGE['DECK_PAGE'] ) {
    InitialiseDeckDialogs();
  }
  InitialiseApexPopupDialog();
}

function InitialiseMainDialogs() {

  
  $("#settings_dialog").dialog( { 
    autoOpen: false,
    modal: true,  
	closeOnEscape: false,
	minWidth: 600,
	minHeight: 400,
	title: 'Settings',
	dialogClass: "dialogClass"
  });
  
  $("#submit_dialog").dialog( { 
    autoOpen: false,
    modal: true,  
	closeOnEscape: false,
	minWidth: 300,
	minHeight: 200,
	title: 'Submit',
	dialogClass: "dialogClass"
  });
  

  
  $('#login_operator_selection').change(function() {
    	
  });
  
  $('#login_type_selection').change(function() {
	SetAvailableDropdownList($('#login_type_selection').val(), $('#login_id_selection'));
  });
}

function InitialiseApexPopupDialog() {
    $("#apex_popup").dialog( { 
    autoOpen: false,
    modal: true,  
	closeOnEscape: false,
	width: window.screen.width - 250,
	height: window.screen.height - 200,
	title: 'WELS Info',
	resizable: true,
	dialogClass: "dialogClass",
	beforeClose: function(event, ui) { $('#apex_popup').html('');}
  });
}

function InitialiseDeckDialogs() {

  

  $("#popup_dialog").dialog( {
    autoOpen: false
  });
  
  $("#create_dialog").dialog( { 
    autoOpen: false,
    modal: true,  
	minWidth: 600,
	minHeight: 400,
	draggable: true,
	resizable: false,
	position: 'left',
	title: 'Create New Container',
    dialogClass: "dialogClass",
	close: function(event,ui) { ClearContainerData() }
  });
  
  $("#deck_tools_popup").dialog( { 
    autoOpen: false,
    modal: true,  
	closeOnEscape: false,
	minWidth: 800,
	minHeight: 400,
	dialogClass: "dialogClass",
	title: 'View and Sync Containers'
  });
}

/*
* Destroy dialogs for deck
*/
function DestroyDialogs(page) {
  if(page == G_PAGE['DECK_PAGE']) {
    $("#popup_dialog").dialog("destroy").remove();
    $("#deck_tools_popup").dialog("destroy").remove();
    $("#create_dialog").dialog("destroy").remove();
  }
  else if(page == G_PAGE['BULK_PAGE']) {
    $("#bulk_tank_dialog").dialog("destroy").remove();
    $("#bulk_popup").dialog("destroy").remove();
  }
}

/*
* Dialog for bulk tank data 
*/
function InitialiseBulkDialogs() {

  $("#bulk_tank_dialog").dialog( { 
    autoOpen: false,
    modal: true,  
	closeOnEscape: false,
	minWidth: 1000,
	minHeight: 500,
	dialogClass: "dialogClass",
	title: 'Bulk Tank Details'
  });
  
  $("#bulk_popup").dialog( { 
    autoOpen: false,
    modal: true,  
	closeOnEscape: false,
	width: window.screen.width - 250,
	height: window.screen.height - 200,
	title: 'Tank Cleaning',
	resizable: true,
	dialogClass: "dialogClass",
	beforeClose: function(event, ui) { $('#bulk_popup').html('');}
  });
  
}

 /*******************************************************************************
  Functions for login dialog
********************************************************************************/

/*
* Shows log in dialog
*/
function LoginDialog(p_master_object, p_data) {
  VRC.LoadingModal.hide();
  g_master_data.ParseMasterData(p_master_object, p_data);
  //$('#login_dialog').dialog('open');
  
  var l_operator_value = localStorage['login_operator_param'];  
  var l_value = localStorage['login_user_param'];
  
  if( l_value !== undefined && l_value !== null && $('#login_type_selection option[value="' + l_value + '"]').length > 0 ) {
    $('#login_type_selection').val( l_value );
    $('#login_type_selection').attr('disabled', true);
  }
  else {
    $('#login_type_selection').val( l_value );
	  $('#login_type_selection').attr('disabled', false);
  }
  
  
  if( l_operator_value !== undefined && l_operator_value !== null) {
    $('#login_operator_selection').val( l_operator_value );
	$('#login_operator_selection').attr('disabled', true);
	SetAvailableDropdownList(l_value, $('#login_id_selection'));
  }
  else {
    $('#login_operator_selection').val( l_operator_value );
	$('#login_operator_selection').attr('disabled', false);  
  }

  VRC.Authentication.init();
}

/*
* Sets dropdown list for logging as rig or vessel
*/
function SetAvailableDropdownList(p_type, $p_dropdown_list) {
  $p_dropdown_list.html('');
  var l_list;
  if(p_type == 'vessel') {
    l_list = g_master_data.GetList('vessel_list');
  }
  else {
    l_list = g_master_data.GetList('port_list');
  }
  for(var l_key in l_list) {
    if( l_list[l_key].type === undefined || l_list[l_key].type == p_type) {
      $p_dropdown_list.append( $("<option />").val(l_list[l_key].id).text(l_list[l_key].name));  
	}
  }
}


/*
* Sets display info of whom user is
*/
function SetLoginInformation( p_name, p_operator ) { 
   $('#id_name').text( p_name );
   try {
     $('#operator_name').html('<img src="images/operators/'+ $.trim( p_operator.toLowerCase() ) + '.png" alt="' + p_operator + '"/>' ); 
   }
   catch(l_err) {
     $('#operator_name').html('<span><Could not log in</span>')// Just leave it empty. 
   }
}

/*******************************************************************************
  Hover dialog functionality
********************************************************************************/

/*
* Shows popup window for currently "selected" container ( hovering over )
*/
function HoverInfoBox( p_obj, p_show ) {
  if( p_show && !g_isDragging ) {
    var containerId = $(p_obj).attr('id');
    var container = VRC.ContainerManager.getContainerById(containerId);
    VRC.ContainerPopoverView.show(p_obj, container);
  } 
  else {
    VRC.ContainerPopoverView.hide(p_obj);
  }
}



 /*******************************************************************************
  Functions create container dialog
********************************************************************************/

/*
* Opens up the create container dialog
*/
function OpenContainerDialog( p_id ) {
 VRC.ContainerEditModal.show(p_id);
}

/*
* Closes the create container dialog
* TODO: Link container creation area to deck size
*/
function CloseContainerDialog() {
  $("#create_dialog").dialog('close');  // implicitly calls clear container data
}

/*
* Clears all data from container creation popup
*/
function ClearContainerData() {
  $('#create_info').find('.container_input_clear').val('');
}

/*********************************************************************************
* Settings dialog
*********************************************************************************/
/* 
* For viewing or hiding the settings dialog
*/
function Settings( p_open ) {
  if( p_open )
    $('#settings_dialog').dialog('open');  
  else {
    $('#settings_dialog').dialog('close');    
  }  
}

/*
* Logs on again, clearing old data
*/
function Relog() {

  var msg = 'This will delete your local saved data and return you to the main log-in screen. Do you want to continue?';
  var onConfirm = function(){
    localStorage.clear();
    window.location.replace('index.html');
  };
  VRC.ConfirmationModal.show({msg : msg, onConfirm : onConfirm});
}

/*
* Clears work data ( containers, bulk, log, fuel, but not tanks or decks  )
*/
function ClearWorkingData() {
  var msg = 'This deletes all your containers, bulk_data, voyage log entries and fuel ROB entries from screen and local storage. Do you want to continue?';
  var onConfirm = function(){
    g_localsave_object.RemoveLocalStorageItem( G_LS_NAMES.BULK_TANKS );
    g_voyage_planning.ClearLocalStorage();
    ClearAllContainers();
    var currentVoyage = VRC.CurrentVoyage.getCurrentVoyage();
    if(currentVoyage){
      currentVoyage.clear();
    }

    g_localsave_object.RemoveLocalStorageItem( G_LS_NAMES.DECK_CONTAINER_DATA);
    location.reload();
  };
  VRC.ConfirmationModal.show({msg : msg, onConfirm : onConfirm});

}

/*
* Fetches master data again
*/
function GetMasterData() {
  var msg = 'This will fetch latest master data from server and reload the page. Make sure you\'ve saved your data and have an Internet connection. Do you want to continue?';
  var onConfirm = function(){
    location.reload();
  };

  VRC.ConfirmationModal.show({msg : msg, onConfirm : onConfirm});
}

/*
* Callback function for loading master data again
*/
function LoadMasterData(p_master_object, p_data) {
  p_master_object.ParseMasterData(p_master_object, p_data);
  window.location.replace('deckstate.html');  
}

/*
* Fetches master data again
*/
function GetBulkTanks() {
  var msg  = 'This will fetch bulk tanks registered for the vessel again. Make sure you\'ve saved your data and have an Internet connection. Do you want to continue?';
  var onConfirm = function(){
    if(g_current_page == G_PAGE['BULK']) {
      var fetchingBulkTanks = VRC.BulkState.fetchBulkTanks();

      fetchingBulkTanks.done(function(){
        LoadPage( G_PAGE.BULK_PAGE );
      });

    }
    else {
      var fetchingBulkTanks = VRC.BulkState.fetchBulkTanks();
    }
  };

  VRC.ConfirmationModal.show({msg : msg, onConfirm : onConfirm});
}

/*
* Prints out all local storage data to a webpage for debugging purposes
*/
function PrintLocalData() {
  var local_output = g_localsave_object.PrintLocalStorageData(localStorage);
  var output = window.open('./output.html');
  output.document.write('<html><head><title></title></head><body>' + '<div><h2>Vessel Data (working data)</h2>' + JSON.stringify(g_data_list) + '</div>' + local_output +  ' </body></html>');
  output.document.close();
}
